// @givmo/board — every word CBG-AI5-CLOSED adds to the confirmation page (D-CBG-44): a past record
// proposed as a closed session's own, or marked so by a person before confirming, goes into the
// minute book as a closed session's record entered by hand does (backend `board-ai-proposals.md`):
// any current director can open it, and its openings are recorded in its history (D-CBG-25; a seat
// on a committee alone is not a director's, so "current director" is the true scope).
//
// ══ WHICH WORDS ARE APPROVED ════════════════════════════════════════════════════════════════════
//
// All of them. The marker is reused word for word from the minute book's own
// (`../records/records-page.tsx`); every other line was a draft until CBG-UX-COPY5's round approved
// it (D-CBG-52, Jonathan, in-chat 2026-11-01 11:53 PST), as built but the way to take the mark off,
// which says what the record becomes, in its dialog's own words: "Mark as an ordinary record", never
// "Mark as not a closed session". Before the round, the orchestrator's eye on the renders
// (2026-10-29 14:02 PDT) took "sent to you" out: nothing is sent. CBG-FIX172 (Givmo MCP's L2 on
// the AI's words, carried here so a person and an AI read the same fact): "each opening is
// recorded" overstated it, since a reader's openings within an hour are recorded as one, so the
// lines say "its openings are recorded in its history".
//
// ⚠ Plan §3.2 and §3.4 bind every line: what the record is and where it goes, never a conclusion
// about a matter. The mark is the record's, whoever set it, so no line names the AI (D-CBG-45: a
// line that does says "AI assistant").

/** The closed-session words of the confirmation page, every one approved (D-CBG-52). */
export const closedProposalWords = {
  /** Reused, the minute book's marker: a closed session's record, under its kind and date. */
  closedSession: 'Closed session',
  /** Approved: a row's ⋯ menu, by the mark the record carries. */
  markClosed: 'Mark as a closed session',
  markNotClosed: 'Mark as an ordinary record',
  /** Approved: the dialog each way, saying who will read the record before the person chooses. */
  markClosedTitle: 'Mark as a closed session?',
  markClosedBody: (title: string) =>
    `“${title}” goes into your minute book as a closed session’s record. Any current director can open it, and its openings are recorded in its history.`,
  markNotClosedTitle: 'Mark as an ordinary record?',
  markNotClosedBody: (title: string) =>
    `“${title}” goes into your minute book as an ordinary record, open to everyone who can read your minute book.`,
  markIt: 'Mark it',
  /** Approved: the confirmation, before the records going in as closed sessions' (copy 6.3's form). */
  closedCount: (n: number) =>
    n === 1
      ? '1 goes in as a closed session’s record. Any current director can open it, and its openings are recorded in its history:'
      : `${n} go in as closed sessions’ records. Any current director can open them, and their openings are recorded in their histories:`,
} as const;
